import { useFeatureToggle } from '../configuration/featureFlags/useFeatureToggle';
import { TRACKING_CATEGORIES } from '../configuration/setup/googleAnalytics';

type BaseCampaign = { trackingCategory: string };
export type DefaultCampaign = BaseCampaign & { type: 'default' };
export type VideoCampaign = BaseCampaign & { type: 'video'; url: string; startSeconds?: number };
type Campaign = DefaultCampaign | VideoCampaign;

export const useGetUpsellingCampaign = (): Campaign => {
    const upsellingCampaign = useFeatureToggle('upsellingCampaign', 'campaign0');

    switch (upsellingCampaign) {
        case 'campaignA':
            return {
                type: 'video',
                url: 'https://www.youtube.com/embed/e780U5qQ4co',
                trackingCategory: TRACKING_CATEGORIES.UPSELLING_A,
                startSeconds: 30,
            };
        case 'campaignB':
            return {
                type: 'video',
                url: 'https://www.youtube.com/embed/wLzgg0LEVHE',
                trackingCategory: TRACKING_CATEGORIES.UPSELLING_B,
            };
        default:
            return {
                type: 'default',
                trackingCategory: TRACKING_CATEGORIES.UPSELLING,
            };
    }
};
